export enum TripGenerationMode {
  None = -1,
  Daily = 0,
  Weekly = 1,
  ManualEntry = 2,
  ManualEntry9 = 3,
  ManualEntry24 = 4,
  ManualEntry45 = 5,
  MonthManualEntry = 6,
  MonthManualEntry9 = 7,
  MonthManualEntry24 = 8,
  MonthManualEntry45 = 9,
  Foreign = 10,
}
